(function () {
  'use strict';

  // This shows the combined status of the associated offer and campaign to a publisher
  // but only the campaign status to the admin
  angular.module('ringbaPortal').component('campaignStatus', {
    bindings: {
      campaign: '<',
      statusObj: '<',
      isAffiliate: '<',
      showOfferSummary: '&'
    },
    controller: CampaignStatusController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/campaign-list-name/campaign-status/campaign-status.view.html'
  });

  function CampaignStatusController(
    $translate
  ) {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;
    vm.openOfferSummaryModal = openOfferSummaryModal;

    function onChanges(changesObj) {
      if (vm.statusObj && (changesObj.statusObj || changesObj.isAffiliate)) {
        vm.tooltipText = $translate.instant(_getTooltipTranslation(vm.statusObj, vm.isAffiliate));
      }
    }

    function openOfferSummaryModal() {
      if (vm.isAffiliate && vm.statusObj.showOfferSummary) {
        vm.showOfferSummary({ campaign: vm.campaign });
      }
    }

    function _getTooltipTranslation(statusObj, isAffiliate) {
      if (isAffiliate) {
        return statusObj.isOffer ? statusObj.tooltipForPublisherOffer : statusObj.tooltipForPublisherCampaign;
      }
      return statusObj.tooltipForAdmin;
    }
  }

})();
